export default "__VITE_ASSET__9a67e697__"